import React from 'react'
import { Flex, Box } from 'grid-styled'
import { Field } from 'redux-form'
import {
  renderTextInput,
  renderValidThruInput,
  renderCardInput,
  renderCvcInput
} from '../../../utils/renderInputs'
import { validateCreditCardFlag } from '../EditPaymentForm/validators'
import { MasterCard, Visa, Elo, Amex } from 'app/elements/CardFlags'
import { Icon } from 'app/elements/Icon'
import {
  required,
  validateExpireDate,
  validateCVV,
  validateAmexCVV
} from '../../../utils/validators'
import { CardFlagList, CardFlagItem } from './styles'
import { deepCerise } from 'styles/settings/colors'
import aleloIcon from '../../../static/alelo.png'
const { labels } = require('./data.json')

function CreditPaymentForm({ formValues, type }) {
  function checkCreditCardFlag(cardNumber) {
    const creditCardFlag = validateCreditCardFlag(cardNumber)
    if (creditCardFlag) {
      return creditCardFlag
    } else {
      return undefined
    }
  }

  function handleChange(value) {
    if (type === 'CAJA') {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'event',
        eventCategory: 'veloe:area-logado:dados-plano',
        eventAction: 'interacao:campo:credito',
        eventLabel: `preencheu:[[${value}]]`
      })
    } else if (type === 'CARTAO_DEBITO') {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'event',
        eventCategory: 'veloe:area-logado:dados-plano',
        eventAction: 'interacao:campo:debito',
        eventLabel: `preencheu:[[${value}]]`
      })
    }
  }

  const creditCardFlag = checkCreditCardFlag((formValues && formValues.cardNumber) || '')

  const validateSecurityCode =
    creditCardFlag === 'amex' ? [required, validateAmexCVV] : [required, validateCVV]
  return (
    <Flex direction="column">
      <Box width={[1, 380]} mb={[24, 28]}>
        <Field
          component={renderCardInput}
          label={labels.cardNumber}
          maxlength={19}
          name="cardNumber"
          onFocus={() => handleChange('numero-cartao')}
          placeholder={labels.placeholder.cardNumber}
          validate={required}
          labelIcon={<Icon icon="lock" width="100" height="100" viewBox="0 0 100 100" />}
        />
        <CardFlagList>
          <CardFlagItem hideCard={creditCardFlag !== undefined && creditCardFlag !== 'elo'}>
            <Elo />
          </CardFlagItem>
          <CardFlagItem hideCard={creditCardFlag !== undefined && creditCardFlag !== 'master'}>
            <MasterCard />
          </CardFlagItem>
          <CardFlagItem hideCard={creditCardFlag !== undefined && creditCardFlag !== 'visa'}>
            <Visa />
          </CardFlagItem>
          <CardFlagItem hideCard={creditCardFlag !== undefined && creditCardFlag !== 'amex'}>
            <Amex />
          </CardFlagItem>
          <CardFlagItem hideCard={creditCardFlag !== undefined && creditCardFlag !== 'alelo'}>
            <img src={aleloIcon} width="40px" height="24px" alt="Alelo" />
          </CardFlagItem>
        </CardFlagList>
      </Box>
      <Box width={[1, 380]} mb={[17, 20]}>
        <Field
          component={renderTextInput}
          label={labels.yourName}
          onFocus={() => handleChange('nome')}
          placeholder={labels.placeholder.yourName}
          name="fullName"
          validate={required}
        />
      </Box>
      <Flex direction={['column', 'row']} width={[1, 380]}>
        <Box mb={[17, 20]} mr={33} width={[1, 200]}>
          <Field
            component={renderValidThruInput}
            label={labels.validThru}
            onFocus={() => handleChange('validade')}
            maxlength={7}
            placeholder={labels.placeholder.validThru}
            name="validThru"
            validate={[required, validateExpireDate]}
          />
        </Box>
        <Box mb={[17, 37]} width={[1, 300]}>
          <Field
            component={renderCvcInput}
            label={labels.securityCode}
            onFocus={() => handleChange('codigo-seguranca')}
            maxlength={creditCardFlag === 'amex' ? 4 : 3}
            placeholder={
              creditCardFlag === 'amex'
                ? labels.placeholder.amexSecurityCode
                : labels.placeholder.securityCode
            }
            name="cvv"
            validate={validateSecurityCode}
            tooltip="O código de segurança de seu cartão (CVV) é o número de 3 ou 4 dígitos localizado no verso da maioria dos cartões."
            tooltipColor={deepCerise}
            limitDigit={creditCardFlag === 'amex' ? 4 : 3}
            tooltipPositionRight
            endIcon={<Icon icon="info" width="100" height="100" viewBox="0 0 100 100" />}
          />
        </Box>
      </Flex>
    </Flex>
  )
}

export default CreditPaymentForm
